/// <amd-module name="CodeCoverage/CodeCoverageTab/Components/CodeCoverageModuleFilterBar" />
import { CodeCoverageTabActionCreator } from 'Actions/CodeCoverageTabActionCreator';
import * as Resources from 'CodeCoverage/CodeCoverageTab/Resources';
import * as React from 'react';
import { VssComponent, IVssComponentDetail, IVssComponentContext } from 'VSS/Platform/Layout';
import { FilterBar } from 'VSSUI/FilterBar';
import { KeywordFilterBarItem } from "VSSUI/TextFilterBarItem";
import { IPickListItem } from 'VSSUI/PickList';
import { Filter, FILTER_CHANGE_EVENT, IFilter, IFilterState } from 'VSSUI/Utilities/Filter';


export interface ICodeCoverageModuleFilterBarState {
    filter: IFilter;
}

export interface IConfigurationItem extends IPickListItem {
    value: string;
}

export class CodeCoverageModuleFilterBar extends VssComponent<{}, ICodeCoverageModuleFilterBarState> {
    private actionCreator: CodeCoverageTabActionCreator;

    constructor(props: any, context: IVssComponentContext) {
        super(props);

        this.actionCreator = CodeCoverageTabActionCreator.getInstance(context);
        this.state = {
            filter: new Filter()
        };
    }

    public componentDidMount() {
        this.state.filter.subscribe(this._onFilterChanged, FILTER_CHANGE_EVENT);
    }
    
    public componentWillUnmount() {
        this.state.filter.unsubscribe(this._onFilterChanged, FILTER_CHANGE_EVENT);
    }

    public render() {
        return (
        <div className="module-filterbar-container">
            <FilterBar filter={this.state.filter}>
                <KeywordFilterBarItem
                    filterItemKey="moduleFilter"
                    placeholder={Resources.CoverageModuleFilterPlaceholder}
                />
            </FilterBar>
        </div>
        );
    }

    private _onFilterChanged = () => {
        const filterState: IFilterState = this.state.filter.getState();
        this.actionCreator.updateModuleFilter(filterState.moduleFilter ? filterState.moduleFilter.value : "");
    }
}
